<template>
  <div>
    <header class="login-header">
      <div class="logo">
        <img :src="$store.getters.settings.client.logo_2x" :srcset="$store.getters.settings.client.logo_4x +' 2x'"
             alt="logo">
      </div>
      <a v-if="$store.getters.settings.client.bilingual" :href="switchPath" class="language-toggle--overlay">عربي</a>
    </header>
    <main role="main" class="intro-pages-content">
      <section class="website-section website-form">
        <div class="container container--small">
          <form class="form-wrapper" v-on:submit.prevent="submit()">
            <fieldset>
              <legend class="legend-title">Request Access</legend>
              <p class="form-desc">
                Please fill the form below for any requests related to the brand guidelines
              </p>
              <input class="form-input"
                     type="text"
                     placeholder="Name*"
                     @blur="$v.formData.name.$touch()"
                     :class="{'is-invalid':$v.formData.name.$error}"
                     v-model="formData.name">
              <input class="form-input"
                     type="email"
                     placeholder="Email*"
                     @blur="$v.formData.email.$touch()"
                     :class="{'is-invalid':$v.formData.email.$error}"
                     v-model="formData.email">
              <input class="form-input" type="text" placeholder="Subject" v-model="formData.subject">
              <textarea class="form-text-area" placeholder="Your message…" v-model="formData.message"></textarea>
              <div class="form-actions">
                <a class="t-text-color form-actions__link">*Mandatory field.</a>
                <div class="form-btns-group">
                  <button class="btn default-btn" @click="$router.push({'name':'Login'})">Cancel</button>
                  <button class="btn t-bg-color">Send</button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </section>
      <div class="popup submission" v-if="showModal" @click.self="showModal = false">
        <div class="popup-info submission-info">
          <div class="submission-info__icon check"></div>
          <div class="popup-info__message">
            Thank you!
            <br>
            Your request will be reviewed soon
          </div>
          <button class="popup-btn btn t-bg-color" @click.self="showModal = false">Done</button>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    computed: {
      switchPath () {
        return '/ar' + this.$route.path
      }
    },
    data () {
      return {
        showModal: false,
        formData: {
          name: '',
          email: '',
          subject: '',
          message: ''
        }
      }
    },
    validations: {
      formData: {
        name: {
          required
        },
        email: {
          required,
          email
        }
      }
    },
    methods: {
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          let qs = require('qs')
          this.axios.post('/signup/submit', qs.stringify(this.formData))
            .then(response => {
              if (response.data.success === 'success') {
                this.showModal = true
                this.formData = {
                  name: '',
                  email: '',
                  subject: '',
                  message: ''
                }
                this.$v.$touch()
                this.$v.$reset()
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },
    created () {
      this.$store.dispatch('setIsLoaded', true)
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Signup.vue